import './agentToggle.css';

/**
 * The ⚡ Agent builder switch (owner, 2026-11-04): one tap between the everyday builder and the
 * agent builder, marked with a glowing bolt. A real switch (role="switch") so a screen reader says
 * whether it is on.
 */
export default function AgentToggle({ on, onChange }: { on: boolean; onChange: (on: boolean) => void }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      className={`agent-toggle pressable${on ? ' is-on' : ''}`}
      onClick={() => onChange(!on)}
      data-testid="agent-toggle"
    >
      <svg className="agent-bolt" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M13.5 2 4 13.5h6.5L9.5 22 20 9.5h-6.6L13.5 2z" />
      </svg>
      <span className="agent-toggle-label">Agent builder</span>
      <span className="agent-toggle-track" aria-hidden="true">
        <span className="agent-toggle-knob" />
      </span>
    </button>
  );
}
